import { FormikErrors } from 'formik';
import { pluralize } from '~/utils';

import { MAX_TAGS, MIN_TAGS } from './ThemesAndAffinities.constants';
import { ThemesAndAffinitiesValues } from './ThemesAndAffinities.types';

export const ThemesAndAffinitiesValidate = (
  fields: ThemesAndAffinitiesValues,
) => {
  let errors: FormikErrors<ThemesAndAffinitiesValues> = {};
  if (fields.themesAndAffinities.length < MIN_TAGS) {
    errors.themesAndAffinities = `Min. ${MIN_TAGS} ${pluralize(
      'tag',
      'tags',
      MIN_TAGS,
    )}`;
  }
  if (fields.themesAndAffinities.length > MAX_TAGS) {
    errors.themesAndAffinities = `Max. ${MAX_TAGS} ${pluralize(
      'tag',
      'tags',
      MAX_TAGS,
    )}`;
  }
  return errors;
};
